<template>
  <div class="page-product">
    <div class="space-20"></div>
    <loading v-if="!loaded.skus || !loaded.product"></loading>
    <div v-show="loaded.skus && loaded.product" class="container">
      <p v-if="product">
        <router-link :to="{name: 'home'}">Catálogo</router-link>
        <i class="fa fa-angle-double-right"></i>
        <router-link :to="getRouteParams()">{{ product.subcategory.name }}</router-link>
        <i class="fa fa-angle-double-right"></i> {{ product.name }}
      </p>
      <div class="row">
        <div class="col-md-3">
          <ul class="list-group characteristics">
            <li class="list-group-item">
              <label class="no-margin">FILTROS</label>
            </li>
            <li v-for="char in product.characteristics" class="list-group-item">
              <h4 class="list-group-item-heading">{{ char.name }}</h4>
              <div class="list-group-item-text">
                <div v-for="(qnt, value) in char.values" class="checkbox">
                  <span class="badge">{{ qnt }}</span>
                  <label>
                    <input name="filters" v-model="filters" :value="char.id + '-' + value" type="checkbox" v-on:change="applyFilter(char.id, value)"/> {{ value }} {{ char.unit }}
                  </label>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="col-md-9">
          <list-skus parent="product" :parent-id="productId" :filters="filters" @loaded="loadedEvent"></list-skus>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex'
  import _ from 'lodash'
  import ListSkus from './../components/ListSkus'

  export default{
    name: 'PageProduct',
    components: { ListSkus },
    data () {
      return {
        product: false,
        characteristics: false,
        productId: this.$route.params.productId,
        filters: this.$route.query.filters || [],
        tagInterval: false,
        loaded: {
          skus: false,
          product: false
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.user
      })
    },
    mounted () {
      this.getProduct()
    },
    beforeDestroy () {},
    methods: {
      getRouteParams (params) {
        return {
          name: 'subcategory',
          params: {
            categorySlug: this.product.subcategory.category.slug,
            subcategorySlug: this.product.subcategory.slug,
            subcategoryId: this.product.subcategory.id
          }
        }
      },
      applyFilter (id, value) {
        let params = {
          name: 'product',
          params: {
            productSlug: this.product.slug,
            productId: this.product.id
          },
          query: {}
        }
        if (this.companyId) params.query.company_id = this.companyId
        params.query.filters = _.join(this.filters, '_')
        this.$router.push(params)
      },
      getProduct () {
        this.loadProduct({id: this.productId, with: 'subcategory,characteristics'})
          .then((response) => {
            this.product = response.data
            if (this.$route.query.filters) {
              this.filters = _.split(this.$route.query.filters, '_')
            }
            this.loadedEvent('product')
          }, (response) => {
            console.log('error: Loading product resource from API')
          })
      },
      loadedEvent (type) {
        if (type === 'skus') this.loaded.skus = true
        if (type === 'product') this.loaded.product = true
      },
      ...mapActions(['loadProduct'])
    }
  }
</script>


// WEBPACK FOOTER //
// PageProduct.vue?7c1577ad